import { ISelectControlOptions } from '../interfaces';

export class SelectControlOptions implements ISelectControlOptions {
  appendTo = '';
  bindLabel = 'caption';
  bindValue = 'id';
  clearable = false;
  clearOnBackspace = false;
  closeOnSelect = true;
  forceCheckBoxes = false;
  groupByTitle = 'caption';
  multiple = false;
  notFoundText = '';
  popover = false;
  searchable = false;

  constructor(data?: ISelectControlOptions) {
    Object.assign(this, data);
  }
}
